import auth from '../auth'
import api from '../api'
import {
  validateLogin,
  validateRegister,
  validatePassword,
  validateForgotPassword,
  validateResetPassword
} from '../utils/validators'

export const LOGIN_REQUEST = 'LOGIN_REQUEST'
function loginRequest() {
  return { type: LOGIN_REQUEST }
}

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
function loginSuccess(currentUser) {
  return { type: LOGIN_SUCCESS, currentUser }
}

export const LOGIN_ERROR = 'LOGIN_ERROR'
function loginError(error) {
  return { type: LOGIN_ERROR, error }
}

export function login(email, password) {
  return dispatch => {
    const { valid, error } = validateLogin({ email, password })
    if (!valid) {
      dispatch(loginError(error))
      return
    }
    email = email.toLowerCase()
    dispatch(loginRequest())
    return auth.login(email, password).then(
      ({ currentUser }) => {
        dispatch(loginSuccess(currentUser))
      },
      error => {
        dispatch(loginError(error))
      }
    )
  }
}

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST'
function logoutRequest() {
  return { type: LOGOUT_REQUEST }
}

export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
function logoutSuccess() {
  return { type: LOGOUT_SUCCESS }
}

export const LOGOUT_ERROR = 'LOGOUT_ERROR'
function logoutError(error) {
  return { type: LOGOUT_ERROR, error }
}

export function logout() {
  return dispatch => {
    dispatch(logoutRequest())
    return auth.logout().then(
      () => {
        dispatch(logoutSuccess())
      },
      error => {
        dispatch(logoutError(error))
      }
    )
  }
}

export const REGISTER_REQUEST = 'REGISTER_REQUEST'
function registerRequest() {
  return { type: REGISTER_REQUEST }
}

export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'
function registerSuccess() {
  return { type: REGISTER_SUCCESS }
}

export const REGISTER_ERROR = 'REGISTER_ERROR'
export function registerError(error) {
  return { type: REGISTER_ERROR, error }
}

export function register(data) {
  return dispatch => {
    const { valid, error } = validateRegister(data)
    if (!valid) {
      dispatch(registerError(error))
      return
    }
    data.email = data.email.toLowerCase()
    dispatch(registerRequest())
    return auth.register(data).then(
      () => {
        dispatch(registerSuccess())
      },
      error => {
        dispatch(registerError(error))
      }
    )
  }
}

export const SET_NEXT_URL = 'SET_NEXT_URL'
export function setNextUrl(url) {
  return { type: SET_NEXT_URL, url }
}

export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export function setCurrentUser(currentUser) {
  return { type: SET_CURRENT_USER, currentUser }
}

export const CLEAR_LOGIN_ERROR = 'CLEAR_LOGIN_ERROR'
export function clearLoginError() {
  return { type: CLEAR_LOGIN_ERROR }
}

export const SAVE_ACCOUNT_REQUEST = 'SAVE_ACCOUNT_REQUEST'
function saveAccountRequest() {
  return { type: SAVE_ACCOUNT_REQUEST }
}

export const SAVE_ACCOUNT_SUCCESS = 'SAVE_ACCOUNT_SUCCESS'
function saveAccountSuccess() {
  return { type: SAVE_ACCOUNT_SUCCESS }
}

export const SAVE_ACCOUNT_ERROR = 'SAVE_ACCOUNT_ERROR'
function saveAccountError(error) {
  return { type: SAVE_ACCOUNT_ERROR, error }
}

export function saveAccount(data) {
  return dispatch => {
    dispatch(saveAccountRequest())
    const { valid, error } = validatePassword(data.attributes, true)
    if (!valid) {
      dispatch(saveAccountError(error))
      return
    }
    if (!data.attributes.password) {
      dispatch(saveAccountError({ password: 'New password is required' }))
      return
    }
    return api.updateRetailer(data.id, data).then(
      () => {
        dispatch(saveAccountSuccess())
        dispatch(logout())
        window.location.replace('/login?passwordChanged=true')
      },
      error => {
        dispatch(saveAccountError(error))
      }
    )
  }
}

export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST'
function forgotPasswordRequest() {
  return { type: FORGOT_PASSWORD_REQUEST }
}

export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS'
function forgotPasswordSuccess() {
  return { type: FORGOT_PASSWORD_SUCCESS }
}

export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR'
function forgotPasswordError(error) {
  return { type: FORGOT_PASSWORD_ERROR, error }
}

export function forgotPassword(email, role) {
  return dispatch => {
    const { valid, error } = validateForgotPassword({ email })
    if (!valid) {
      dispatch(forgotPasswordError(error))
      return
    }
    dispatch(forgotPasswordRequest())
    return api.forgotPassword(email.toLowerCase(), role).then(
      () => {
        dispatch(forgotPasswordSuccess())
      },
      error => {
        dispatch(forgotPasswordError(error))
      }
    )
  }
}

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST'
function resetPasswordRequest() {
  return { type: RESET_PASSWORD_REQUEST }
}

export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
function resetPasswordSuccess() {
  return { type: RESET_PASSWORD_SUCCESS }
}

export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR'
function resetPasswordError(error) {
  return { type: RESET_PASSWORD_ERROR, error }
}

export function resetPassword(token, password, confirmPassword) {
  return dispatch => {
    const { valid, error } = validateResetPassword({ password, confirmPassword })
    if (!valid) {
      dispatch(resetPasswordError(error))
      return
    }
    if (!token) {
      dispatch(resetPasswordError({ token: 'Reset token is missing. Please use the link from your email.' }))
      return
    }
    dispatch(resetPasswordRequest())
    return api.resetPassword(token, password).then(
      () => {
        dispatch(resetPasswordSuccess())
      },
      error => {
        dispatch(resetPasswordError(error))
      }
    )
  }
}

export const CLEAR_PASSWORD_RESET_STATE = 'CLEAR_PASSWORD_RESET_STATE'
export function clearPasswordResetState() {
  return { type: CLEAR_PASSWORD_RESET_STATE }
}
